<template>
  <div>
    <el-button type="warning" @click="act('do')">开始维护</el-button>
    <p></p>
    <el-button type="success" @click="act('cancel')">解除维护</el-button>
  </div>
</template>

<script>
import bizutil from "@/bizutil";
import util from "@/util";
const axios = require("axios");

export default {
  methods: {
    async act(action) {
      if (action == "do") {
        try {
          await this.$confirm("确定将所有分区置为维护状态（同时逐步将所有玩家踢下线）？", "警告", {
            type: "warning",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          });
        } catch (e) {
          return;
        }
      } else if (action == "cancel") {
        try {
          await this.$confirm("确定为所有分区解除维护状态？", "警告", {
            type: "warning",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          });
        } catch (e) {
          return;
        }
      }

      try {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/manageZoneMaintenance`,
            {
              action: action,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message.success("操作成功");
      } catch (err) {
        this.$message.error(err);
      }
    },
  }
}
</script>